import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {TopBarComponent} from "../../top-bar/top-bar.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {HeroAbotUsComponent} from "./hero-abot-us/hero-abot-us.component";
import {MisionVisionComponent} from "./mision-vision/mision-vision.component";
import {OurValoresComponent} from "./our-valores/our-valores.component";
import {PoliticAndQualityComponent} from "./politic-and-quality/politic-and-quality.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [
    NavBarComponent,
    TopBarComponent,
    FooterPersonaComponent,
    HeroAbotUsComponent,
    MisionVisionComponent,
    OurValoresComponent,
    PoliticAndQualityComponent,
    FloatButtonComponent
  ],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent {

}
